export const ROOT_SECTIONS_KEY = 'risk_details.sections';
export const SPLIT_BY_SECTIONS_KEY = 'risk_details.split_by_sections';
export const SECTION_TITLE_KEY = 'section_title';
